module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Complaints/complaints.component.html
// module id = ./src/app/Complaints/complaints.component.html
// module chunks = main